<div class="dashboard-layout">
  <!-- Header -->
  <header class="dashboard-header">
    <div class="header-left">
      <button type="button" class="burger-btn" (click)="toggleSidebar()" [attr.aria-label]="sidebar.isOpen() ? 'Close menu' : 'Open menu'" [attr.aria-expanded]="sidebar.isOpen()">
        <i class="bi" [class.bi-x-lg]="sidebar.isOpen()" [class.bi-list]="!sidebar.isOpen()"></i>
      </button>
      <button
        *ngIf="canGoBack()"
        type="button"
        class="appbar-back-btn"
        (click)="goBack()"
        aria-label="Back">
        <i class="bi bi-arrow-left"></i>
      </button>
      <a routerLink="/dashboard" class="dashboard-title app-brand" [attr.aria-label]="brand.productName">
        <img
          class="app-brand-logo"
          [src]="brand.logoMark"
          [srcset]="brand.logoMarkSrcset"
          alt=""
          decoding="async" />
      </a>
    </div>
    <div class="dashboard-header-actions">
      <!-- News bell: visible only on mobile (CSS-gated). Replaces the bottom
           news card which users could not find. -->
      <button
        type="button"
        class="header-bell-btn"
        (click)="toggleNewsBell()"
        [attr.aria-expanded]="newsBellOpen"
        aria-label="News"
        aria-haspopup="dialog">
        <i class="bi bi-bell"></i>
        @if (newsUnreadCount > 0) {
          <span class="header-bell-badge">{{ newsUnreadCount > 9 ? '9+' : newsUnreadCount }}</span>
        }
      </button>
      @if (recentMilestones.length > 0) {
        <div class="header-badges" aria-label="Earned badges" data-testid="header-badges">
          @for (milestone of recentMilestones; track milestone.milestoneId || milestone.title) {
            <span
              class="header-badge"
              [attr.title]="milestone.title + (milestone.subjectName ? ' · ' + milestone.subjectName : '') + (milestone.xpAwarded ? ' · +' + milestone.xpAwarded + ' XP' : '')"
            >
              <i class="bi bi-award-fill" aria-hidden="true"></i>
              <span class="header-badge-label">{{ milestone.title }}</span>
            </span>
          }
        </div>
      }
      <a routerLink="/dashboard/my-profile" class="header-link"><i class="bi bi-person"></i> {{ userName }}</a>
      <span class="header-sep">|</span>
      <a routerLink="/logout" class="header-link logout-link">Logout</a>
    </div>
  </header>

  @if (newsBellOpen) {
    <div class="news-bell-backdrop" (click)="closeNewsBell()" (keydown)="$event.key === 'Escape' && closeNewsBell()" role="button" tabindex="0" aria-label="Close news"></div>
    <div class="news-bell-panel" role="dialog" aria-label="News">
      <div class="news-bell-header">
        <h3 class="news-bell-title"><i class="bi bi-bell"></i> News</h3>
        <button type="button" class="news-bell-close" (click)="closeNewsBell()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      @if (newsLoading) {
        <p class="news-bell-empty">Loading news…</p>
      } @else if (newsList.length === 0) {
        <p class="news-bell-empty">No news at the moment.</p>
      } @else {
        <div class="news-bell-list">
          @for (item of newsList; track item.id) {
            <article class="news-bell-item">
              <header class="news-bell-item-header">
                <h4 class="news-bell-headline">{{ item.headline }}</h4>
                <time class="news-bell-meta">{{ item.createdAt | date:'yyyy-MM-dd HH:mm' }}</time>
              </header>
              <div class="news-bell-text" [innerHTML]="item.text | safeHtml"></div>
            </article>
          }
        </div>
      }
    </div>
  }

  <div class="dashboard-body">
    <!-- Desktop-only permanent sidebar. On mobile/Capacitor this is hidden via
         CSS and the globally-mounted <app-sidebar-drawer> takes over so the
         same menu is reachable from the navbar burger on tab pages. -->
    <aside class="dashboard-sidebar dashboard-sidebar-static">
      <nav class="sidebar-nav">
        <div class="sidebar-section">
          <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-link">
            <i class="bi bi-house"></i>
            <span>Dashboard</span>
          </a>
        </div>
        <div class="sidebar-section">
          <div class="sidebar-section-header">ACCOUNT</div>
          <a routerLink="/dashboard/subscriptions" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-credit-card"></i>
            <span>Subscriptions</span>
          </a>
          <a routerLink="/dashboard/my-profile" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-person"></i>
            <span>My Profile</span>
          </a>
          <a routerLink="/dashboard/settings" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-gear"></i>
            <span>Settings</span>
          </a>
        </div>
        <div class="sidebar-section sidebar-section-study">
          <div class="sidebar-section-header">STUDY</div>
          <a routerLink="/dashboard/question-flags" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-flag"></i>
            <span>Flagged Questions</span>
          </a>
          <a routerLink="/dashboard/my-comments" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-chat-left-text"></i>
            <span>My Comments</span>
          </a>
          <a routerLink="/dashboard/my-notes" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-sticky"></i>
            <span>My Notes</span>
          </a>
        </div>
        @if (messagingEnabled) {
        <div class="sidebar-section sidebar-section-comm">
          <div class="sidebar-section-header">SOCIAL</div>
          <a routerLink="/dashboard/messages" routerLinkActive="active" class="sidebar-link sidebar-link-messages">
            <i class="bi bi-envelope"></i>
            <span>Messages</span>
            @if (unreadCount > 0) {
              <span class="sidebar-badge">{{ unreadCount }}</span>
            }
          </a>
        </div>
        }
        @if (isAdmin()) {
          <div class="sidebar-section">
            <div class="sidebar-section-header">ADMIN</div>
            <a routerLink="/admin" routerLinkActive="active" class="sidebar-link sidebar-link-admin">
              <i class="bi bi-gear-wide-connected"></i>
              <span>Admin</span>
            </a>
          </div>
        }
      </nav>
    </aside>

    <main class="dashboard-main">
      <router-outlet></router-outlet>
      <app-legal-footer></app-legal-footer>
    </main>
  </div>

  @if (newMessagesDialog) {
    <div class="new-messages-overlay" role="dialog" aria-modal="true" aria-labelledby="new-messages-title">
      <div class="new-messages-dialog">
        <h2 id="new-messages-title" class="new-messages-title">
          <i class="bi bi-envelope"></i>
          You have {{ dialogUnreadCount }} new message{{ dialogUnreadCount !== 1 ? 's' : '' }}
        </h2>
        <p class="new-messages-text">Would you like to read them now?</p>
        <div class="new-messages-actions">
          <button type="button" class="btn btn-primary" (click)="goToMessages()">Go to Messages</button>
          <button type="button" class="btn btn-outline-secondary" (click)="stayOnDashboard()">Stay on Dashboard</button>
        </div>
      </div>
    </div>
  }
</div>
